import { Link } from "gatsby";
import IntelLogo from "../../../../src/assets/images/partners/intel_blue.svg";
import Layer5Logo from "../../../../src/assets/images/layer5/layer5-only/svg/layer5-no-trim.svg";
import * as React from 'react';
export default {
  Link,
  IntelLogo,
  Layer5Logo,
  React
};